import { StatusEnum } from '../../Enum/StatusEnum';
import BaseEntity from '../BaseEntity.model';
import { ProviderPreview } from '../CarePlans/SchedulePlan.model';

export default interface ILipidAssessment extends BaseEntity {
    MemberId: string;
    MemberName: string;
    Age: number;
    DOB: string;
    Provider: ProviderPreview;
    Collector: ProviderPreview;
    TestDate: string;
    TotalCholestrol: number;
    HDLCholestrol: number;
    Triglycerides: number;
    eGlu: number;
    IsTotalCholestrolOutOfRange: boolean;
    IsHDLCholestrolOutOfRange: boolean;
    IsTriglyceridesOutOfRange: boolean;
    IseGluOutOfRange: boolean;
    Percentage: number;
    CreatedDate: string;
    CreatedBy: string;
    NeedsReview: boolean;
    Status: StatusEnum;
    LotNumber: string;
    QcChipInformation: string;
    ExpirationDate: string;
    LDLCholestrol: number;
    IsLDLCholestrolOutOfRange: boolean;
    IsCollectorAi: boolean;
    IsTestDateAi: boolean;
    IsHDLCholestrolAi: boolean;
    IsLDLCholestrolAi: boolean;
    IsTriglyceridesAi: boolean;
    IseGluAi: boolean;
    IsLotNumberAi: boolean;
    IsQcChipInformationAi: boolean;
    IsExpirationDateAi: boolean;
    IsTotalCholestrolOutOfRangeAi: boolean;
    IsHDLCholestrolOutOfRangeAi: boolean;
    IsTriglyceridesOutOfRangeAi: boolean;
    IseGluOutOfRangeAi: boolean;
    IsLDLCholestrolOutOfRangeAi: boolean;
    IsTotalCholestrolAi: boolean;
}

export class LipidAssessment implements ILipidAssessment {
    Id: string;
    MemberId: string;
    MemberName: string;
    Age: number;
    DOB: string;
    Provider: ProviderPreview;
    Collector: ProviderPreview;
    TestDate: string;
    TotalCholestrol: number;
    HDLCholestrol: number;
    Triglycerides: number;
    eGlu: number;
    IsTotalCholestrolOutOfRange: boolean;
    IsHDLCholestrolOutOfRange: boolean;
    IsTriglyceridesOutOfRange: boolean;
    IseGluOutOfRange: boolean;
    Percentage: number;
    CreatedDate: string;
    CreatedBy: string;
    NeedsReview: boolean;
    Status: StatusEnum;
    LotNumber: string;
    QcChipInformation: string;
    ExpirationDate: string;
    LDLCholestrol: number;
    IsLDLCholestrolOutOfRange: boolean;
    IsCollectorAi: boolean;
    IsTestDateAi: boolean;
    IsHDLCholestrolAi: boolean;
    IsLDLCholestrolAi: boolean;
    IsTriglyceridesAi: boolean;
    IseGluAi: boolean;
    IsLotNumberAi: boolean;
    IsQcChipInformationAi: boolean;
    IsExpirationDateAi: boolean;
    IsTotalCholestrolOutOfRangeAi: boolean;
    IsHDLCholestrolOutOfRangeAi: boolean;
    IsTriglyceridesOutOfRangeAi: boolean;
    IseGluOutOfRangeAi: boolean;
    IsLDLCholestrolOutOfRangeAi: boolean;
    IsTotalCholestrolAi: boolean;

    constructor() {
        this.Id = '';
        this.MemberId = '';
        this.MemberName = '';
    }
}
